<template>
  <div>
    <header-part />
    <div class="login">
      <div class="top">
        <router-link to="/PC/index">
          <img src="/static/images/login/logo2.png" alt="图片" />
        </router-link>
        <h2>欢迎登录</h2>
      </div>
      <!-- 登录面板 -->
      <div class="content">
        <div class="loginForm">
          <img src="@/assets/bg.jpg" class="img-responsive" draggable="false" alt="图片" />
          <div class="core">
            <div class="title">
              <h2 v-if="isLogin">微信扫码登录</h2>
              <h2 v-else>微信扫码注册</h2>
<!--              <h2 v-if="isLogin">账号登陆</h2>
              <h2 v-if="!isLogin">账号注册</h2> -->
            </div>
            <div class="form" v-if="isLogin" key="1">
              <el-form v-if="isShowForm"
                status-icon
                label-width="40px"
                label-position="left"
                :model="loginForm"
                ref="loginForm"
                :hide-required-asterisk="true"
              >
                <el-form-item
                  label="账号"
                  prop="username"
                  :rules="[{ required: true, message: '账号不能为空' }]"
                >
                  <el-input
                    v-model="loginForm.username"
                    prefix-icon="el-icon-user-solid"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="密码"
                  prop="password"
                  :rules="[{ required: true, message: '密码不能为空' }]"
                >
                  <el-input
                    type="password"
                    v-model="loginForm.password"
                    show-password
                    prefix-icon="el-icon-lock"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                 <el-button type="primary" @click="submitLogin('loginForm')"
                    >登录</el-button
                  >
                </el-form-item>
              </el-form>

              <div >
                <vue-qr class="img-qr" :name="code + xweblogincode" :text="code + xweblogincode" :size="170" :margin="1" ></vue-qr>
                <div v-show="isShowMask" class="warp-mask">
                    <el-button @click="clear" style="margin-top: 150px;">点击重置</el-button>
                </div>
              </div>

              <div>
                <span style="color: red;">{{ errorMsg }}</span>
              </div>

<!--              <el-divider></el-divider>

              <el-button @click="clear">重置</el-button> -->

             <div class="footer" v-if="false">
                <div class="loginSelect">
                  <div class="logo">
                    <span class="icon icon_qq"></span>
                    <span>QQ</span>
                  </div>
                  <div style="position: relative; top: 6px">
                    <el-divider direction="vertical"></el-divider>
                  </div>
                  <div class="logo">
                    <span class="icon icon_weixin"></span>
                    <span>微信</span>
                  </div>
                </div>
                <div class="right">
                  <el-button plain @click="toPage('/PC/login?isLogin=false')"
                    >立即注册</el-button
                  >
                </div>
              </div>

            </div>
            <div class="form" v-else key="2">
              <el-form
                status-icon
                ref="regForm"
                label-width="40px"
                label-position="left"
                :model="regForm"
                :rules="rules"
                v-if="isShowForm"
              >
                <el-form-item label="账号" prop="username">
                  <el-input
                    v-model="regForm.username"
                    prefix-icon="el-icon-user-solid"
                  ></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="password">
                  <el-input
                    type="password"
                    v-model="regForm.password"
                    autocomplete="off"
                    show-password
                    prefix-icon="el-icon-lock"
                  ></el-input>
                </el-form-item>
                <el-form-item label="确认" prop="checkPass">
                  <el-input
                    type="password"
                    v-model="regForm.checkPass"
                    autocomplete="off"
                    show-password
                    prefix-icon="el-icon-lock"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="submitReg('regForm')"
                    >注册</el-button
                  >
                  <el-button @click="toPage('/PC/login?isLogin=true')">
                    登录</el-button
                  >
                </el-form-item>
              </el-form>
              <div>
<!--                <vue-qr class="img-qr" :name="code + xweblogincode" :text="code + xweblogincode" :size="170" :margin="1" ></vue-qr>-->
                <el-image src="/static/images/regist.jpg" style="height: 200px"></el-image>
              </div>
              <div>
                <span style="color: red;">{{ message }}</span>
              </div>
              <el-divider></el-divider>
            </div>
          </div>
        </div>
      </div>

<!--      <wxlogin
        appid="wx658b5f27f9bd18e8"
        :scope="'snsapi_login'"
        :theme="'black'"
        :redirect_uri='encodeURIComponent("https://xmall.houduniot.com/index")'
        :href="'data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZxxx='"
        rel="external nofollow">
      </wxlogin> -->

      <!-- /登录面板 -->
      <my-footer />
    </div>

    <!-- 选择企业对话框 -->
    <el-dialog title="选择企业" :visible.sync="selectEnterpriseOpen" width="500px" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>

      <el-form ref="form" :model="form" :rules="enterpriseRules" label-width="80px">
          <el-form-item label="选择企业" prop="enterpriseId">
          <el-select v-model="form.enterpriseId" placeholder="请选择企业" clearable filterable size="small" >
            <el-option v-for="item in enterpriseList" :key="item.id" :label="item.name" :value="item.id">
              <span style="float: left">{{ item.name }}--{{ item.cusTypeName }}</span>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>


</template>

<script>
// import wxlogin from 'vue-wxlogin'

import MyFooter from '../footer/MyFooter.vue';
import HeaderPart from '../header/HeaderPart.vue';
import { validUserByCode, sureEnterprise } from "@/api/login";
import {getEnterpriseByUserId} from "@/api/user/user"

import vueQr from 'vue-qr'
import Cookies from "js-cookie";

export default {
  components: { MyFooter, HeaderPart, vueQr },
  name: 'Login',
  data() {
    let checkUsername = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('用户名不能为空'));
      }
      callback();
    };
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.regForm.checkPass !== '') {
          this.$refs.regForm.validateField('checkPass');
        }
        callback();
      }
    };
    let validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.regForm.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };

    return {
      enterpriseRules: {
        enterpriseId: [
          { required: true, message: '企业不能为空', trigger: 'blur' }
        ],
      },
      selectEnterpriseOpen: false,
      enterpriseList: [],
      form: {
        enterpriseId: ''
      },

      fromPath: null,
      toPath: null,
      isProd: true,
      // code: 'https://xmall.houduniot.com/?xweblogincode=', //开发版
      // code: 'https://buytest.houduniot.com/?xweblogincode=', //体验版
      code: 'https://buy.houduniot.com/?xweblogincode=', //正式版

      isShowForm: false,
      xweblogincode: '123456',

      isShowMask: false,

      errorMsg: '',
      timer: null,
      time: 0,
      firtGetEnterprise: 1,
      loginForm: {
        username: '',
        password: '',
      },
      regForm: {
        username: '',
        password: '',
        checkPass: '',
      },
      //message注册提示
      message: '请扫码进入小程序注册',
      rules: {
        password: [{ validator: validatePass, trigger: 'blur' }],
        checkPass: [{ validator: validatePass2, trigger: 'blur' }],
        username: [{ validator: checkUsername, trigger: 'blur' }],
      },
    };
  },
  methods: {
    toPage(item) {
      this.$router.push(item);
    },
    clear() {
      this.isShowMask = false;
      if(this.isProd){
        this.xweblogincode = new Date().getTime() + this.rndNum(5)
      }else{
        this.xweblogincode = '123456'
      }
      this.time = 0
      this.loginForm = {
        username: '',
        password: '',
      };
    },
    submitLogin(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.checkLogin(this.loginForm);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    submitReg(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.checkReg(this.regForm);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    checkLogin(userInfo) {
      // 判断用户账号密码是否正确
      // 返回值 true or false
      let obj = {
        userInfo,
        that: this,
      };
      this.$store.commit('getUsersAndCheck', obj);
    },
    checkReg(userInfo) {
      let obj = {
        userInfo,
        that: this,
      };
      this.$store.commit('checkRegAndAdd', obj);
    },
    rndNum(n){
      var rnd="";
      for(var i=0;i<n;i++){
         rnd+=Math.floor(Math.random()*10);
      }
      return rnd;
    },
    validCode(){
      if(this.time > 10){
        this.errorMsg = '二维码过期，请点击重置后再扫码'
        this.isShowMask = true;
        return;
      }
      this.time++
      validUserByCode(this.xweblogincode).then(response => {
        if(!!response.errmsg){
          if(response.errmsg.indexOf('请微信扫码') == -1){
            this.errorMsg = response.errmsg
            this.$store.commit('setUser', response.data);
            Cookies.set('isLogin', 'true', {
              expires: 1,
            })
            console.log("user:",response);
            //业务员  直接跳转
            if(response.data.userInfo.type == 1){
              //办事员登录 弹框选择 企业   并将企业id存入localstorge
              this.selectEnterpriseOpen = true
              if(this.firtGetEnterprise === 1){
                getEnterpriseByUserId(response.data.userInfo.userId).then(res =>{
                  this.firtGetEnterprise++
                  this.form.enterpriseId = ''
                  this.enterpriseList = res.data
                  if(this.enterpriseList.length == 1){
                    localStorage.setItem('enterpriseId', this.enterpriseList[0].id);
                    this.selectEnterpriseOpen = false;
                    this.$router.push( { path: '/PC/index' } )
                  }
                })
              }
            }else {
              if(this.fromPath == '/' || this.fromPath == this.toPath){
                this.$router.push( { path: '/PC/index' } )
              }else{
                // this.$router.go(-1)
                this.$router.push( { path: '/PC/index' } )
              }
            }



          }else if(!!this.errorMsg && this.errorMsg.indexOf("未扫码成功") == -1){

          }else{
            this.errorMsg = response.errmsg
          }
        }else{
          this.errorMsg = '请使用微信扫码'
        }
      });
    },
    submitForm(){
      if (this.form.enterpriseId === undefined || this.form.enterpriseId === '') {
        this.$message.error('请选择企业！');
		    return
      }
      const data = {
        "enterpriseId": this.form.enterpriseId
      }
      sureEnterprise(data).then(res =>{
        if(res.errno == 0){
          this.selectEnterpriseOpen = false;
          this.$router.push( { path: '/PC/index' } )
        }
      })
      // localStorage.setItem('enterpriseId', this.form.enterpriseId);
      // this.selectEnterpriseOpen = false;
      // this.$router.push( { path: '/PC/index' } )
    },
  },
  beforeRouteEnter (to, from, next){
    next(vm => {
      // 通过 `vm` 访问组件实例,将值传入fromPath
      console.log(from)
      console.log(to)
      vm.fromPath = from.path
      vm.toPath = to.path
    })
  },
  computed: {
    isLogin() {
      let isLogin = this.$route.query.isLogin;
      return isLogin === 'true' ? true : false;
    },
  },
  created() {
    if(document.domain == 'xmall.houduniot.com'){//正式环境
      this.code = 'https://buy.houduniot.com/?xweblogincode=';
      this.isProd = true;
    }else{//测试环境
      this.code = 'https://buytest.houduniot.com/?xweblogincode=';
      this.isProd = false;
    }

    this.clear()
    this.timer = setInterval(this.validCode, 3 * 1000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
};
</script>

<style scoped>
.title {
  margin-top: 35px;
  color: #888;
}

.login {
  background: #fff;
}

.top {
  display: flex;
  align-items: center;
  width: 1200px;
  height: 60px;
  margin: 0 auto;
}

.top h2 {
  margin-left: 20px;
  color: #666;
}

.login .content {
  /* background: #f98985; */
  background: #dcdcdc;
}

.login .content .loginForm {
  width: 1200px;
  margin: 0 auto;
}

.login .content .loginForm .core {
  width: 340px;
  height: 360px;
  border-radius: 8px;
  text-align: center;
  box-sizing: border-box;
  padding: 10px 0;
  background: #fff;
  position: absolute;
  top: 120px;
  right: 300px;
}

.form {
  padding: 20px 20px;
}

.login .content .loginForm .footer {
  display: flex;
  justify-content: space-around;
}

.login .content .loginForm .footer .loginSelect {
  color: #666;
  display: flex;
}

.login .content .loginForm .footer .loginSelect .logo {
  padding: 0 4px;
  display: flex;
  align-items: center;
}

.icon {
  width: 19px;
  height: 18px;
  margin: 0 2px;
  display: inline-block;
  background: url(//misc.360buyimg.com/user/passport/1.0.0/widget/login-form-2018-0827/i/QQ-weixin.png)
    no-repeat;
}
.icon_qq {
  background-position: 0 0;
}

.icon_weixin {
  background-position: -20px 0;
}
.qr-shadow{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
    background: rgba(0,0,0,0.3);
}
.warp-mask{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
    background: rgba(0,0,0,.4);
    color: white;
    font-weight: 700;
}

/* .img-responsive {
  display: inline-block;
  height: auto;
  max-width: 100%;
} */
</style>



// WEBPACK FOOTER //
// src/views/PC/Pages/Login.vue